import {
  Service01,
  Service02,
  Service03,
  Service04,
} from 'assets';

export const services = [{
  title: '오늘은 홍대에서 볼까?',
  content: '우리 동네부터 지역별 핫플레이스까지\n전국 5,000개 이상의 데이트 장소',
  image: Service01,
}, {
  title: '캐릭터가 전해주는 데이트 스토리',
  content: '모모-나래, 찰리-소영, 밍키-해태 세 커플이\n전해주는 생동감 넘치는 데이트 스토리',
  image: Service02,
}, {
  title: '직접 다녀온 리얼 후기',
  content: '가격부터 꿀팀까지, 커플들이 직접 다녀온 후\n전해주는 리얼 데이트 리뷰',
  image: Service03,
}, {
  title: '인기 데이트 장소 선착순 할인',
  content: '데이트팝이 검증한 퀄리티 있는 곳을\n할인가로 방문',
  image: Service04,
}];
